export const path = {
  login: '/login',
  signup: '/signup',
  profile: '/profile',
  resetPassword: '/reset-password',
  confirmEmail: '/confirm-email',
  dashboard: '/dashboard',
  pendingapproval: '/pendingapproval',
  pastconsultationpage: '/pastconsultationpage',
  consultation: '/consultation',
  activeconsultationpage: '/activeconsultationpage',
  reviewprescriptions: '/reviewprescriptions',
  PastConsultationDetail: '/PastConsultationDetail',
  viewprescription: '/viewprescription',
  ChatModule: '/ChatModule',
  profileview: '/profileview',
  doctorinformation: '/doctorinformation',
  changepassword: '/changepassword',
  sendmail: '/sendmail',
  labrequistionpage: '/labrequisitionpage',
  labtracking: '/labtracking',
  labedits: '/labedits',
  soapnotes: '/soapnotes',
  viewsoapnotes: '/viewsoapnotes',
  viewresults: '/viewresults',
  viewupdates: '/viewupdates',
  writesoapnotes: '/writesoapnotes',
  results: '/results',
  startchat: '/chat',
}
